// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"c0ea047e","842":"b2c657f6"}[chunkId] + ".chunk.js";
};